<div class="grow overflow-y-auto">
    <valben-table
        [loading]="loading()"
        entityType="Award"
        [columns]="cols"
        [values]="tableValues()"
        [refresh]="refresh"
        [lazy]="true"
        [totalRecords]="totalRecords()"
        (lazyLoad)="loadPage($event)"
        (editEvent)="edit($event)"
        [addLabel]="'Dodaj nagradu'"
        (addEvent)="add()"
    >
    </valben-table>
</div>
